import { render } from "./ResultArticles.vue?vue&type=template&id=aac5594c&ts=true"
import script from "./ResultArticles.vue?vue&type=script&lang=ts"
export * from "./ResultArticles.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__